<template>

	<div id="nested-form" class="scfForm">
		<div v-if="registrationStatus =='Start'" id="formContainer" class="campusForm">
			<div class="scfSingleLineTextBorder" v-html="translationHelper.getTranslation('vdi_unregister_text')">
				
			</div>
			<div class="scfSubmitButtonBorder">
				<button  @click="unregister" >{{translationHelper.getTranslation('vdi_unregister_button')}}</button>
			</div>
		</div>
		<div v-if="registrationStatus =='Success'">
			<div v-html="translationHelper.getTranslation('vdi_unregister_success_text')"></div>
			
		</div>
		<div v-if="registrationStatus =='Fail'">
			<div v-html="translationHelper.getTranslation('vdi_unregister_fail_text')"></div>
			
		</div>
	</div>	
</template>
<script>
	import VDI from "../../../../_Api/VDI";
	export default{
		props: ["translationHelper"]
		,data() {
			return {
				registrationStatus:"Start"
			}
		}
		,methods:{
			unregister(){
				VDI.unregister(null, ()=>this.registrationStatus='Success',  ()=>this.registrationStatus='Fail')
			}
		}
	}
</script>